document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.timeline-carousel__tab');
  const tabContents = document.querySelectorAll('.timeline-carousel__content');

  if (tabContents.length > 0) {
    tabContents[0].setAttribute('aria-hidden', 'false');
    tabContents[0].classList.add('timeline-carousel__content--visible');
    tabButtons[0].classList.add('timeline-carousel__tab--active');
  }

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabIndex = button.getAttribute('data-timeline-tab');

      const activeContent = document.querySelector(`[data-timeline-content="${tabIndex}"]`);

      tabButtons.forEach(btn => btn.classList.remove('timeline-carousel__tab--active'));
      tabContents.forEach(content => {
        content.classList.remove('timeline-carousel__content--visible');
        content.setAttribute('aria-hidden', 'true');
      });

      button.classList.add('timeline-carousel__tab--active');
      activeContent.classList.add('timeline-carousel__content--visible');
      activeContent.setAttribute('aria-hidden', 'false');
    });
  });
});
